import { memo, useState } from 'react';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import InputField from '../../../common/fields/InputField';
import PrimaryButton from '../../../common/buttons/PrimaryButton';
import SectionCard from './SectionCard';

const empty = { recommender_name: '', recommender_relation: '', body: '' };

export default memo(function RecommendationsSection({ recommendations, onChange }) {
  const [form, setForm] = useState(empty);
  const [showForm, setShowForm] = useState(false);

  const handleAdd = () => {
    if (!form.recommender_name || !form.body) return;
    onChange([...recommendations, form]);
    setForm(empty);
    setShowForm(false);
  };

  const handleRemove = (i) => onChange(recommendations.filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Recommendations">
      <div className="space-y-3 mb-4">
        {recommendations.map((r, i) => (
          <div
            key={i}
            className="flex items-start justify-between bg-white/5 border border-white/10 rounded-lg px-4 py-3"
          >
            <div>
              <p className="text-white text-sm font-medium">{r.recommender_name}</p>
              <p className="text-orange-400 text-xs">{r.recommender_relation}</p>
              <p className="text-gray-400 text-xs mt-1 italic">"{r.body}"</p>
            </div>
            <button type="button" onClick={() => handleRemove(i)}>
              <DeleteForeverOutlinedIcon sx={{ color: '#ef4444', fontSize: 20 }} />
            </button>
          </div>
        ))}
      </div>

      {showForm ? (
        <div className="bg-white/5 border border-white/10 rounded-lg p-4 space-y-3">
          <InputField
            label="Recommender Name"
            value={form.recommender_name}
            onChange={(e) => setForm({ ...form, recommender_name: e.target.value })}
          />
          <InputField
            label="Relation"
            value={form.recommender_relation}
            onChange={(e) => setForm({ ...form, recommender_relation: e.target.value })}
          />
          <InputField
            label="Message"
            value={form.body}
            onChange={(e) => setForm({ ...form, body: e.target.value })}
            multiline
            rows={3}
          />
          <div className="flex flex-col sm:flex-row gap-2 justify-end">
            <button
              type="button"
              onClick={() => setShowForm(false)}
              className="px-4 py-2 text-sm text-gray-400 hover:text-white transition"
            >
              Cancel
            </button>
            <PrimaryButton type="button" onClick={handleAdd}>
              Add Recommendation
            </PrimaryButton>
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setShowForm(true)}
          className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg border border-dashed border-orange-500/40 text-orange-400 hover:bg-orange-500/10 transition text-sm font-medium"
        >
          <AddCircleOutlineIcon fontSize="small" /> Add Recommendation
        </button>
      )}
    </SectionCard>
  );
});
